"use strict";
/**
 * CONNOX GMBH CONFIDENTIAL
 * ________________________
 *
 * Copyright (c) 2005 - 2022 Connox GmbH, All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Connox GmbH and its suppliers, if any. The intellectual and
 * technical concepts contained herein are proprietary to Connox GmbH and
 * its suppliers and may be covered by German Laws and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from
 * Connox GmbH.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserEventEmitter = void 0;
const TabLogging_1 = __importStar(require("./TabLogging"));
class BrowserEventEmitter {
    /**
     * Create a new EventEmitter
     */
    constructor(key) {
        this.listeners = [];
        this.listenersOnce = [];
        this.broadcast = new BroadcastChannel(key);
        this.emit = this.emit.bind(this);
        this.on = this.on.bind(this);
        this.once = this.once.bind(this);
        this.sendProxy = this.sendProxy.bind(this);
        this.tabLog = new TabLogging_1.default("BroadcastChannel", this.sendProxy);
        this.broadcast.onmessage = (message) => {
            const { data } = message;
            if (TabLogging_1.isBusControlMessage(data)) {
                this.tabLog.handleBusControlResponse(data);
            }
            else {
                this.invokeListeners(data);
            }
        };
        this.tabLog.sayHello();
    }
    /**
     * Emits the event to its subscribers
     * @param {Payload} payload
     */
    emit(payload) {
        this.broadcast.postMessage(payload);
        this.invokeListeners(payload);
    }
    /**
     * Unsubscribes the listener from the event
     * @param {Listener<Payload>} listener
     */
    off(listener) {
        const listenerIndex = this.listeners.indexOf(listener);
        if (listenerIndex > -1) {
            this.listeners.splice(listenerIndex, 1);
        }
    }
    /**
     * Subscribes a listener to the event
     * @param {Listener<Payload>} listener
     */
    on(listener) {
        this.listeners.push(listener);
    }
    /**
     * Subscribes the listener to receive the event exactly once
     * @param {Listener<Payload>} listener
     */
    once(listener) {
        this.listenersOnce.push(listener);
    }
    /**
     * Information about the tabs involved in BroadcastChannel emitting
     * @returns {IBusLogging}
     */
    get tabInfo() {
        return this.tabLog.tabLog;
    }
    sendProxy(busControl) {
        this.broadcast.postMessage(busControl);
    }
    invokeListeners(payload) {
        for (const listener of [...this.listeners, ...this.listenersOnce]) {
            listener(payload);
        }
        this.listenersOnce = [];
    }
}
exports.BrowserEventEmitter = BrowserEventEmitter;
